import dayjs from "dayjs";
import { DepartureStatus } from "../../../../generated/graphql";
import { useTripBuilder } from "../context/TripBuilderContext";
import { useMemo } from "react";

export const useMapDepartureStatus = (
    departure: ReturnType<typeof useTripBuilder>["departure"],
    callToBookDpd?: string,
): string | null =>
    useMemo(() => {
        if (!departure) {
            return null;
        }

        if (
            departure.status === DepartureStatus.Sell ||
            departure.status === DepartureStatus.OnRequest
        ) {
            if (departure.nbSpotsLeft <= 0) {
                return departure.isWaitlistAllowed
                    ? ("Waitlist" as const)
                    : ("Unavailable" as const);
            }
            const hasCabinCodes = departure.rooms.some(
                (room) => room.cabinCode,
            );

            const isCallToBook =
                !!callToBookDpd && Number(callToBookDpd) >= 0
                    ? dayjs(departure.departureDate).diff(dayjs(), "day") <=
                      Number(callToBookDpd)
                    : departure.status === DepartureStatus.OnRequest;
            if (isCallToBook || hasCabinCodes) {
                return "Call to book" as const;
            }
            return "Available" as const;
        }
        return "Unavailable" as const;
    }, [departure, callToBookDpd]);
